import { parseJsonString } from 'pano-utils';
import {
  type GeneralID,
  LibType,
  type MatrixFov,
  type PanoMultires,
  SceneType,
  type TranscodeTrack,
} from '@types';
import { $sceneMapApi } from '@stores/dataStores';
import { getLibPVideoData } from '@apis/mediaApis';
import { selectLibScenes } from '../../mediaLib';

const getNav = (
  sceneType: SceneType
): Parameters<typeof selectLibScenes>[0]['nav'] | undefined => {
  if (sceneType === SceneType.pano) return [LibType.pano];
  if (sceneType === SceneType.matrix) return [LibType.matrix];
  if (sceneType === SceneType.panoVideo) return [LibType.panoVideo];
};

async function replaceScene({
  sceneType,
  id,
}: {
  sceneType: SceneType;
  id: GeneralID;
}) {
  const nav = getNav(sceneType);
  if (!nav) return;
  const { panos, panoVideos, matrices } = await selectLibScenes({ nav });
  if (panos) {
    const data = panos[0];
    $sceneMapApi.update((draft) => {
      const item = draft.get(id)!;
      item.materialId = data.id;
      item.multires = parseJsonString(data.multires) as PanoMultires;
      item.path = data.path;
      item.cdnDomain = data.cdnDomain;
      item.thumbUrl = data.qiniuThumbUrl;
    });
  } else if (panoVideos) {
    const data = panoVideos[0];
    const x = await getLibPVideoData(data.id);
    $sceneMapApi.update((draft) => {
      const item = draft.get(id)!;
      item.materialId = data.id;
      item.transcodeTrack = parseJsonString(
        data.transcodeTrack
      ) as TranscodeTrack;
      item.cdnDomain = data.cdnDomain;
      item.thumbUrl = data.thumbUrl;
      item.originTrack = x.originTrack;
    });
  } else if (matrices) {
    const data = matrices[0];
    $sceneMapApi.update((draft) => {
      const item = draft.get(id)!;
      item.materialId = data.id;
      item.multires = parseJsonString(data.multires) as PanoMultires;
      item.path = data.path;
      item.matrixFov = parseJsonString(data.fov) as MatrixFov;
      item.cdnDomain = data.cdnDomain;
      item.thumbUrl = data.thumbUrl;
    });
  }
}

export default replaceScene;
